import FJConstant from '../../constants/FJConstant.js';
import FJMusicIcon from '../../assets/svg/music.svg?react';
import FJInstrumentalIcon from '../../assets/svg/instrumental.svg?react';
import FJSoundEffectIcon from '../../assets/svg/sound-effect.svg?react';

const FJAIAudioGeneratorData = {
    MENU_LIST: [
        {
            name: 'music',
            value: FJConstant.VOCAL,
            icon: FJMusicIcon,
        },
        {
            name: 'instrumental',
            value: FJConstant.INSTRUMENTAL,
            icon: FJInstrumentalIcon,
        },
        {
            name: 'sound-effect',
            value: FJConstant.SOUND_EFFECT,
            icon: FJSoundEffectIcon,
        },
    ],
};

export default FJAIAudioGeneratorData;
